import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { store } from 'store/index'

import ReactSelect from 'pages/parts/ReactSelect'
import PhotoScanModal from 'pages/main/documentsIn/PhotoScanModal'
import { SHOW_LOADER, HIDE_LOADER } from 'store/loader/actions'
import { httpOk, GET, POST, PUT } from 'helpers/api'
import { handleDecimalKeyDown } from 'helpers/decimalKey'
import { formatDate, formatMoney, returnMinDate, notify } from 'helpers/helpers'
import { bestMatch, ELEMENT_MATCH_THRESHOLD } from 'helpers/documentInPhoto'

function CreateUpdate() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({
		'products': [],
		'pos_id': reduxAccount.pos_id,
		'wms_id': null,
		'to_pos_id': null,
		'supplier_id': null,
		'note': '',
		'created_at': formatDate(new Date(), 'yyyy-MM-dd'),
	})
	const [addQuantity, setAddQuantity] = useState(1)
	const [poses, setPoses] = useState([])
	const [wms, setWms] = useState([])
	const [externalPoses, setExternalPoses] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [items, setItems] = useState([])
	const [itemsDuplicate, setItemsDuplicate] = useState([])
	const [modalPhoto, setModalPhoto] = useState(false)

	async function createUpdate() {
		var dataCopy = { ...data }
		dataCopy.error = false

		if (dataCopy.products.length === 0) {
			notify(t('add_elements'))
			return
		}

		for (let i = 0; i < dataCopy.products.length; i++) {
			if (!dataCopy.products[i]['quantity']) {
				dataCopy.error = true
			}
		}

		// Строка с фото могла остаться без товара — сохранять такую нечего
		for (let i = 0; i < dataCopy.products.length; i++) {
			if (!dataCopy.products[i]['product_id']) {
				notify(`${t('check_filled_inputs')}: ${i + 1}`)
				return
			}
		}

		var valueArr = dataCopy.products.map(function (item) { return item.product_id });
		var isDuplicate = valueArr.some(function (item, idx) {
			return valueArr.indexOf(item) !== idx
		});

		if (isDuplicate) {
			notify(t('identical_elements'))
			return
		}

		if (dataCopy.error) {
			notify(t('check_filled_inputs'))
			return
		}

		if (id) {
			const response = await PUT('/wms-transfer-branch', dataCopy, { loader: true })

			if (httpOk(response)) navigate('/wms-transfer-branch')
			return
		}

		if (!id) {
			const response = await POST('/wms-transfer-branch', dataCopy, { loader: true })

			if (httpOk(response)) navigate('/wms-transfer-branch')
		}
	}

	function addToList(length = 1) {
		var dataCopy = JSON.parse(JSON.stringify(data))

		for (let i = 0; i < length; i++) {
			dataCopy.products.push({
				'id': '',
				'product_id': '',
				'sale_price': '',
				'quantity': '',
			})
		}
		countTotalAmount(dataCopy)

		setTimeout(() => {
			const byId = document.getElementById(`input-select-${dataCopy.products.length}`)
			byId.select()
		}, 200);

	}

	async function deleteItem(index) {
		var dataCopy = JSON.parse(JSON.stringify(data))
		dataCopy.products.splice(index, 1)

		countTotalAmount(dataCopy)
	}

	function countTotalAmount(dataCopy) {
		dataCopy.total_quantity = 0
		dataCopy.total_amount = 0
		for (let i = 0; i < dataCopy.products.length; i++) {
			dataCopy.total_quantity += Number(dataCopy.products[i]['quantity'])
			dataCopy.total_amount += (Number(dataCopy.products[i]['quantity']) * Number(dataCopy.products[i]['cost_price']))
		}

		setData(dataCopy)
	}

	async function handleSelectPos(option) {
		const wmsId = await getWms(option.id)
		getProducts(option.id, wmsId)
	}

	// Сменили склад — товары те же, пересчитываем только остаток в строках
	function handleSelectWms(option) {
		getProducts(data.pos_id, option.id, true)
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }

		dataCopy.products[index][e.target.name] = e.target.value
		countTotalAmount(dataCopy)
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (!value) {
			setItems([...itemsDuplicate])
			return
		}
		var elementsDuplicateCopy = [...itemsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setItems(filteredItems)
	}

	function handleSelectProduct(option, index) {
		var dataCopy = { ...data }

		// Позицию с фото сопоставляют руками уже после того, как количество подставили,
		// поэтому при первом выборе товара его не затираем
		const previous = dataCopy.products[index]
		const fromPhoto = !!previous?.suggested_name && !previous?.product_id

		dataCopy.products[index] = fromPhoto ? { ...option, 'quantity': previous.quantity } : option

		countTotalAmount(dataCopy)
	}

	// ПЕРЕМЕЩЕНИЕ ПО ФОТО
	// Раскладываем распознанную накладную по форме: примечание и позиции.
	// Что не совпало со справочником — остаётся строкой с подсказкой, товар выбирает пользователь.
	function applyRecognized(recognized) {
		if (!recognized) return

		var dataCopy = { ...data }

		if (recognized.document_number && !dataCopy.note) {
			dataCopy.note = `№${recognized.document_number}`
		}

		const usedProductIds = []
		const products = []
		for (let i = 0; i < (recognized.items?.length ?? 0); i++) {
			const recognizedItem = recognized.items[i]
			const name = String(recognizedItem.name ?? '').trim()
			if (!name) continue

			const available = itemsDuplicate.filter(item => !usedProductIds.includes(item.product_id))
			const product = bestMatch(name, available, ELEMENT_MATCH_THRESHOLD)
			const quantity = Number(recognizedItem.quantity) > 0 ? String(Number(recognizedItem.quantity)) : ''

			if (product) {
				usedProductIds.push(product.product_id)
				products.push({ ...product, 'suggested_name': name, 'quantity': quantity })
			} else {
				products.push({ 'id': '', 'product_id': '', 'suggested_name': name, 'quantity': quantity })
			}
		}

		// Ненайденные — наверх, чтобы сразу было видно, что нужно доработать руками
		products.sort((a, b) => (a.product_id ? 1 : 0) - (b.product_id ? 1 : 0))

		dataCopy.products = products
		countTotalAmount(dataCopy)
	}

	const photoItemsCount = data.products.filter(item => item.suggested_name).length
	const photoNotFoundCount = data.products.filter(item => item.suggested_name && !item.product_id).length
	// ПЕРЕМЕЩЕНИЕ ПО ФОТО

	function closeReactSelect() {
		setTimeout(() => {
			var elementsCopy = [...items]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i]['selected'] = false
			}
			if (elementsCopy[0] && elementsCopy[0]['selected'])
				elementsCopy[0]['selected'] = true
			setItems(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = items.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...items]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[items.length - 1].selected = true
						currentIndex = items.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === items.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setItems(elementsCopy)
		}
	}
	// REACTSELECT LOGIC

	async function getData() {
		store.dispatch(SHOW_LOADER());

		var response
		response = await GET('/helper/poses', {}, {})
		if (httpOk(response)) setPoses(response.data)

		response = await GET('/helper/poses-chain-transfer', {}, {})
		if (httpOk(response)) setExternalPoses(response.data)

		response = await GET('/helper/internal-suppliers', {}, {})
		if (httpOk(response)) setSuppliers(response.data)

		if (id) {
			response = await GET(`/wms-transfer-branch/${id}`, {}, {})
			if (httpOk(response)) {
				// Документ уже отправлен и не правится: показываем склад, с которого списали
				await getWms(response.data.pos_id)
				countTotalAmount({
					...response.data,
					'products': (response.data.items ?? []).map(item => ({ ...item, 'name': item.product_name })),
				})
			}
		} else {
			const wmsId = await getWms(reduxAccount.pos_id)
			await getProducts(reduxAccount.pos_id, wmsId)
		}

		store.dispatch(HIDE_LOADER());
	}

	// Склады точки-отправителя; по умолчанию корневой — его же берёт бэкенд, если склад не передан
	async function getWms(pos_id) {
		const response = await GET(`/helper/wms?pos_id=${pos_id}`, {}, {})
		if (!httpOk(response)) return null

		setWms(response.data)
		const defaultWms = response.data.find(item => !item.parent_id) ?? response.data[0]
		return defaultWms?.id ?? null
	}

	async function getProducts(pos_id = reduxAccount.pos_id, wms_id = data.wms_id, keepProducts = false) {
		var response = await GET(`/wms-transfer-branch-items/${pos_id}`, wms_id ? { 'wms_id': wms_id } : {}, {})
		if (httpOk(response)) {
			setItems(response.data)
			setItemsDuplicate(response.data)

			var dataCopy = { ...data }
			dataCopy.pos_id = pos_id
			dataCopy.wms_id = wms_id
			if (keepProducts) {
				dataCopy.products = dataCopy.products.map(product => {
					const item = response.data.find(el => el.product_id === product.product_id)
					return item ? { ...product, 'balance': item.balance } : product
				})
			} else {
				dataCopy.products = []
			}

			countTotalAmount(dataCopy)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('transfer_between_branches')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
				{!id &&
					<div className="d-flex gap-2">
						{/* Отдельной кнопкой, а не пунктом меню — иначе про перемещение по фото никто не узнает */}
						<button type="button" className="btn btn-outline-primary btn-rounded"
							disabled={!data.pos_id}
							onClick={() => setModalPhoto(true)}>
							<i className="uil uil-camera me-1"></i>
							{t('transfer_by_photo')}
						</button>
					</div>
				}
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											yearDropdownItemNumber={2}
											disabled={id}
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), 20)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('pos')}<span className="required-mark">*</span></label>
									<Select
										isDisabled={id}
										options={poses}
										value={poses.find(option => option.id === data.pos_id)}
										onChange={(option) => handleSelectPos(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('from_wms')}<span className="required-mark">*</span></label>
									<Select
										isDisabled={id}
										options={wms}
										value={wms.find(option => option.id === data.wms_id) || null}
										onChange={(option) => handleSelectWms(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('branch')}<span className="required-mark">*</span></label>
									<Select
										isDisabled={id}
										options={externalPoses}
										value={externalPoses.find(option => option.id === data.to_pos_id)}
										onChange={(option) => setData({ ...data, 'to_pos_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('supplier')}<span className="required-mark">*</span></label>
									<Select
										options={suppliers}
										value={suppliers.find(option => option.id === data.supplier_id)}
										onChange={(option) => setData({ ...data, 'supplier_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control" name="note"
										value={data.note ?? ''}
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="card">
					<div className="card-body">
						{photoNotFoundCount > 0 &&
							<div className="alert alert-warning">
								<div className="fw-600">
									{photoNotFoundCount} / {photoItemsCount} {t('positions_not_found')}
								</div>
								<div>{t('transfer_positions_not_found_hint')}</div>
							</div>
						}

						<div className="table-responsive">
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '40%' }}>{t('name2')}</th>
										<th style={{ 'width': '10%' }}>{t('type')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
										<th style={{ 'width': '10%' }} className="text-start">{t('unit')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('cost_price')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
										<th style={{ 'minWidth': '33px' }}></th>
									</tr>
								</thead>
								<tbody>
									{data?.products?.map((item, index) => (
										<tr key={index}>
											<td className="text-center">{index + 1}</td>
											<td>
												<ReactSelect
													search={handleSelectSearch}
													value={item.name}
													index={index}
													scrollRef={scrollRef}
													options={items}
													onClose={() => closeReactSelect()}
													selectItem={(option) => handleSelectProduct(option, index)}
													onKeyUp={(e) => {
														if (e.keyCode === 40 || e.keyCode === 38) {
															handleTableKeyDown(e)
														}
													}}
													table={
														<table className="table mb-0">
															<tbody ref={tbodyRef}>
																{items.map((selectItem, selectIndex) => (
																	<tr
																		id={selectItem.id}
																		className={`cursor ${((selectItem.selected || selectItem.product_id === item.id) && 'selected')}`}
																		tabIndex={-1}
																		key={selectIndex}
																		onClick={() => handleSelectProduct(selectItem, index)}
																		onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																		<td>{selectItem.name}</td>
																		<td>{selectItem.product_type_name}</td>
																		<td className="text-end text-nowrap">{formatMoney(selectItem.cost_price)}</td>
																	</tr>
																))}
															</tbody>
														</table>
													}
												/>
												{/* Наименование с фото — видно, пока позицию не сопоставили со справочником */}
												{item.suggested_name &&
													<small className={item.product_id ? 'text-muted' : 'text-danger'}>
														{item.product_id ? t('from_photo') : t('not_found_in_handbook')}: {item.suggested_name}
													</small>
												}
											</td>
											<td>{item.product_type_name}</td>
											<td className="text-end vertical-middle">
												{formatMoney(item.balance, 2)}
											</td>
											<td className="text-start vertical-middle">
												{item.unit_name}
											</td>
											<td className="td-input" style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}>
												<input
													type="text"
													name="quantity"
													className="form-control text-end"
													placeholder="0"
													value={item.quantity ?? ''}
													onChange={(e) => handleInputChange(e, index)}
													onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))} />
											</td>
											<td className="text-end vertical-middle">
												{formatMoney(item.cost_price)}
											</td>
											<td className="vertical-middle text-end text-nowrap">
												{formatMoney(item.quantity * item.cost_price)}
											</td>
											<td className="vertical-middle">
												{!id &&
													<div className="d-flex justify-content-center">
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteItem(index)}>
															<i className="uil uil-times"></i>
														</div>
													</div>
												}
											</td>
										</tr>
									))}
								</tbody>
								<tfoot>
									<tr>
										<td className="td-input">
											<input
												type="text"
												className="form-control text-center"
												style={{ 'padding': '5px 0' }}
												placeholder="xxx"
												value={addQuantity}
												onChange={(e) => setAddQuantity(e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, ''))}
											/>
										</td>
										<td colSpan={1} style={{ 'padding': 0 }}>
											<div className="d-flex">
												<div className="w-100">
													<button type="button" className="btn-sm btn-primary w-100"
														onClick={() => {
															setAddQuantity(1)
															addToList(addQuantity)
														}}>
														{t('add')}
													</button>
												</div>
											</div>
										</td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end"><b>{formatMoney(data.total_quantity, 2)}</b></td>
										<td></td>
										<td className="text-end"><b>{formatMoney(data.total_amount, 2)}</b></td>
										<td></td>
									</tr>
								</tfoot>
							</table>
						</div>

						<div className="btn-wrapper gap-2">
							<button type="button" className="btn btn-warning btn-rounded btn-wide" tabIndex="-1"
								onClick={() => navigate(-1)}>
								{t('cancel')}
							</button>
							{/* PUT /wms-transfer-branch — это приёмка на стороне филиала, правки отправленного документа нет */}
							{!id &&
								<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
									disabled={!(data.pos_id && data.wms_id && data.products.length)}
									onClick={() => createUpdate(1)}>
									{t('confirm')}
								</button>
							}
						</div>
					</div>
				</div>
			</form>

			{/* ПЕРЕМЕЩЕНИЕ ПО ФОТО */}
			<PhotoScanModal
				show={modalPhoto}
				mode="transfer"
				posId={data.pos_id}
				onClose={() => setModalPhoto(false)}
				onApply={applyRecognized}>
			</PhotoScanModal>
			{/* ПЕРЕМЕЩЕНИЕ ПО ФОТО */}
		</>
	)
}

export default CreateUpdate